import { deliveryMenus } from "./menus";
import { importMenu } from "./import-menu";
import { deliverySettings } from "./settings";
import { deliveryReport } from "./report";
import { syncMenu } from "./sync-menu";

export const delivery = {
	goBack: "Volver",
	updateManyExternalIntegrations: {
		success: "Integraciones actualizadas con éxito",
	},
	externalStoreIntegrationStatus: {
		synced: "Sincronizado",
		pendingSyncing: "Sincronización pendiente",
		pendingImporting: "Importación pendiente",
	},
	deliverySettings,
	deliveryReport,
	deliveryMenus,
	syncMenu,
	importMenu,
};
